import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query MarkersInDirectory($id: Int!) {
  markersInDirectory(id: $id) {
    id
    description
    name
    answerTemplates {
      id
      text
      value
    }
  }
}`;

function markersInDirectory(id) {
  return apollo.client.query({
    variables: {
      id: parseInt(id, 10),
    },
    query,
    fetchPolicy: 'network-only',
  })
    .then((res) => res.data.markersInDirectory);
}

export default markersInDirectory;
